import { render, staticRenderFns } from "./updateReasonModal.vue?vue&type=template&id=753b9233"
import script from "./updateReasonModal.vue?vue&type=script&lang=js"
export * from "./updateReasonModal.vue?vue&type=script&lang=js"
import style0 from "./updateReasonModal.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports